// API Configuration
export const API_BASE_URL = import.meta.env.PROD
  ? ''
  : (import.meta.env.VITE_API_URL || 'http://localhost:5000');

// Tier Configuration
export const TIER_CONFIG = {
  tiers: {
    1: {
      name: 'Free',
      profitShare: 0.40,
      monthlyFee: 0,
      requiresNFT: false,
    },
    2: {
      name: 'NFT + Monthly',
      profitShare: 0.20,
      monthlyFee: 29.90,
      requiresNFT: true,
    },
    3: {
      name: 'Premium',
      profitShare: 0.10,
      monthlyFee: 0.00,
      requiresNFT: true,
    },
  },
  nftValidityMonths: 12,
} as const;
